import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { teamPlanLabel } from '../team/teamAcceptMessages';
import { WorkspaceMark } from './WorkspaceMark';
import { workspaceMessages } from './workspaceMessages';
import type { WorkspaceSummary } from './useWorkspaces';
import { Panel } from '../music24/components/primitives/Panel';
import styles from './LeaveWorkspaceModalBody.module.scss';

interface LeaveWorkspaceModalBodyProps {
  /** The workspace to leave. Null while `workspaces.list` loads: the row is left out. */
  workspace: WorkspaceSummary | null;
  /** The name of the home workspace, for the text. Null while it is not known. */
  homeName: string | null;
  /** The text without the home name. */
  fallbackBody: string;
}

/**
 * design: workspaces e2. The body of the leave confirm, from the zone (e1) and from "Your
 * workspaces" (d1, e1): the workspace row (mark, name, owner, plan) and the text that names the
 * home workspace.
 */
const LeaveWorkspaceModalBodyComponent: React.FC<LeaveWorkspaceModalBodyProps> = ({
  workspace,
  homeName,
  fallbackBody,
}) => {
  const intl = useIntl();
  return (
    <>
      {workspace !== null && (
        <Panel nested className={styles.row}>
          <WorkspaceMark licenseId={workspace.licenseId} name={workspace.name} size="medium" />
          <div>
            <b>{workspace.name}</b>
            <small className={styles.meta} data-clarity-mask="true">
              {intl.formatMessage(workspaceMessages.ownedByPlan, {
                email: workspace.ownerEmail,
                plan: teamPlanLabel(intl, workspace.plan),
              })}
            </small>
          </div>
        </Panel>
      )}
      <p className="mb-0">
        {homeName === null ? fallbackBody : intl.formatMessage(workspaceMessages.leaveBodyNamed, { home: homeName })}
      </p>
    </>
  );
};

export const LeaveWorkspaceModalBody = TypedMemo(LeaveWorkspaceModalBodyComponent);
